import AxiosService from './axios.service';
import ConfigService from './config.service';

const getCurrentUser = async () => {
    const res = await AxiosService.getInstance.get(`${ConfigService.appConfig.baseApiUrl}/User`);
    return res.data;
};

const UserService = {
    getCurrentUser
};

export default UserService;
